import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import './src/assets/css/style.css';

//Sections
import Main from "./src/components/main/Index";

/**
 * Página institucional
 */

class Index extends React.Component {


  componentDidMount() {
   
  }


  render() {
    return (
      <React.Fragment>
          <Main />
      </React.Fragment>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(state => {
      return {};
    }, {})(Index)
  )
);
